import React from "react";

const ToggleBtn = ({ isOn = false, onChange, size = 50 }) => {
  const height = size / 2;
  const circleSize = height - 4;
  const translateX = size - height;

  return (
    <div
      onClick={() => onChange && onChange(!isOn)} // toggle via parent
      style={{ width: size, height: height }}
      className={`flex items-center rounded-full p-1 cursor-pointer transition-colors duration-300 ${
        isOn ? "bg-[#FF6943]" : "bg-gray-300"
      }`}
    >
      <div
        style={{
          width: circleSize,
          height: circleSize,
          transform: isOn ? `translateX(${translateX}px)` : "translateX(0px)",
        }}
        className="bg-white rounded-full shadow-md transition-transform duration-300"
      />
    </div>
  );
};

export default ToggleBtn;
